import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getLegislationUsingDestination = api(async function legislationUsingDestination({
    url,
    excludeId = null,
}) {
    return query(
        gql`
            query LegislationUsingDestination($url: String!, $excludeId: String) {
                legislationUsingDestination(url: $url, excludeId: $excludeId) {
                    id
                    title
                }
            }
        `,
        { url, excludeId },
        { returns: "legislationUsingDestination", fetchPolicy: "network-only" }
    )
})
